import { ErrorDetails } from './error-details.model';

export interface ProblemDetails {
    /**
     * A human-readable explanation specific to this occurrence of the problem.
     */
    detail: string;

    /**
     * A URI reference that identifies the specific occurrence of the problem.It may or may not yield further information if dereferenced.
     */
    instance: string;

    /**
     * The HTTP status code([RFC7231], Section 6) generated by the origin server for this occurrence of the problem.
     */
    status: number;

    /**
     * A short, human-readable summary of the problem type.It SHOULD NOT change from occurrence to occurrence
     * of the problem, except for purposes of localization(e.g., using proactive content negotiation;
     * see[RFC7231], Section 3.4).
     */
    title: string;

    /**
     * A URI reference [RFC3986] that identifies the problem type. This specification encourages that, when
     * dereferenced, it provide human-readable documentation for the problem type
     * (e.g., using HTML [W3C.REC-html5-20141028]).  When this member is not present, its value is assumed to be
     * "about:blank".
     */
    type: string;

    /**
     * Additional model properties.
     * Depending on the problem/error.
     */
    [property: string]: any;
}

export interface ValidationProblemDetails extends ProblemDetails {
    /**
     * Gets the validation errors associated with this instance of `ValidationProblemDetails`.
     */
    errors: { [key: string]: string[] };

    /**
     * Guid trace id of the error.
     */
    trackId?: string;
}

export const getErrorMessages = (error: ValidationProblemDetails): ErrorDetails[] => {
    if (!error || (!!error && !('errors' in error) && !('translationCode' in error))) {
        return [];
    }

    if ('translationCode' in error) {
        return [error] as unknown as ErrorDetails[];
    }

    const errors: ErrorDetails[] = [];
    let errorDetails: ErrorDetails = {
        message: error.title,
        statusCode: error.status,
    };
    errors.push(errorDetails);

    for (const errorMessages of Object.values(error.errors)) {
        for (const message of errorMessages) {
            errorDetails = {
                message,
                statusCode: error.status,
            };

            errors.unshift(errorDetails);
        }
    }

    return errors;
};
